import React, {Component} from 'react'
import PropTypes from 'prop-types'

var breakpoints = {
  desktop: {min: '1200px', max: Infinity},
  laptop: {min: '1024px', max: '1199px'},
  tablet: {min: '768px', max: '1023px'},
  mobile: {min: '0', max: '767px'},
  mobileAndTablet: {min: '0', max: '1023px'},
  all: {min: '0', max: Infinity}
}

class RenderAt extends Component {
  static defaultProps = {
    breakpoints: breakpoints
  }

  static propTypes = {
    breakpoints: PropTypes.object,
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    desktop: PropTypes.bool,
    fragment: PropTypes.bool,
    laptop: PropTypes.bool,
    mobile: PropTypes.bool,
    style: PropTypes.object,
    tablet: PropTypes.bool
  }

  constructor (props) {
    super(props)

    this.state = {
      matches: false
    }

    this.devices = []
    if (this.props.desktop) this.devices.push('desktop')
    if (this.props.laptop) this.devices.push('laptop')
    if (this.props.tablet) this.devices.push('tablet')
    if (this.props.mobile) this.devices.push('mobile')
    if (this.devices.length === 0) this.devices.push('all')
  }

  componentWillMount () {
    window.addEventListener('resize', this.handleWindowSizeChange)
    this.handleWindowSizeChange()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleWindowSizeChange)
  }

  handleWindowSizeChange = () => {
    let availableDevices = []
    this.devices.forEach(device => {
      if (this.props.breakpoints[device].max === Infinity) {
        availableDevices.push(window.matchMedia('screen and (min-width: ' + this.props.breakpoints[device].min + ')').matches)
      } else {
        availableDevices.push(window.matchMedia('screen and (min-width: ' + this.props.breakpoints[device].min + ') and (max-width: ' + this.props.breakpoints[device].max + ')').matches)
      }
    })

    this.setState({matches: availableDevices.indexOf(true) !== -1})
  }

  render () {
    if (!this.state.matches) {
      return null
    }

    if (this.props.fragment) {
      return <React.Fragment>{this.props.children}</React.Fragment>
    }

    return <div className={this.props.className} style={this.props.style}>{this.props.children}</div>
  }
}

export default RenderAt

function isMobile () {
  return window.matchMedia('screen and (min-width: ' + breakpoints.mobile.min + ') and (max-width: ' + breakpoints.mobile.max + ')').matches
}

function isTablet () {
  return window.matchMedia('screen and (min-width: ' + breakpoints.tablet.min + ') and (max-width: ' + breakpoints.tablet.max + ')').matches
}

function isLaptop () {
  return window.matchMedia('screen and (min-width: ' + breakpoints.laptop.min + ') and (max-width: ' + breakpoints.laptop.max + ')').matches
}

function isDesktop () {
  return window.matchMedia('screen and (min-width: ' + breakpoints.desktop.min + ')').matches
}

function isMobileAndTablet () {
  return window.matchMedia('screen and (min-width: ' + breakpoints.mobileAndTablet.min + ') and (max-width: ' + breakpoints.mobileAndTablet.max + ')').matches
}

export {isMobile, isDesktop, isLaptop, isTablet, isMobileAndTablet}
